/* eslint-disable import/prefer-default-export */

import api, { 
  multiPartHeader, 
  partHeader, 
  apiInternal 
} from '../api';

export async function setEsta(estaData) {
  const tags = [];
  if (estaData.tags && estaData.tags.length > 0) {
    (estaData.tags).forEach((item) => {
      tags.push(item.tag_id);
    });
  }
  const { data } = await api.post(`${apiInternal}/setEstablishment`,
    {
      esta_id: estaData.esta_id,
      esta_internal_name: estaData.esta_internal_name,
      esta_nice_name: estaData.esta_nice_name,
      esta_name: estaData.esta_name,
      parent_id: estaData.parent_id,
      esta_address: estaData.esta_address,
      esta_city: estaData.esta_city,
      esta_postalcode: estaData.esta_postalcode,
      esta_country: estaData.esta_country,
      esta_email: estaData.esta_email,
      esta_phone: estaData.esta_phone,
      esta_is_internal: estaData.esta_is_internal,
      esta_is_enable: estaData.esta_is_enable,
      tags,
      lemon_project_tag: estaData.lemon_project_tag,
    });
  return data;
}


export async function getAllEsta(params) {
 const { data } = await api.post(`${apiInternal}/establishments/list`, params);
  return data;
}


export async function getEstaByid(estaId) {
  const { data } = await api.post(`${apiInternal}/establishment/details`, { esta_id: estaId });
  return data;
}

export async function getDevices(estaId){
  const {data} = await api.post(`${apiInternal}/establishment/params/getDevices`, { esta_id: estaId });
  return data;
}
export async function getUnassociatedEsta() {
  const {data} = await api.post(`${apiInternal}/getUnassociatedEstablishments`,{});
   
   return data; 
 }

 export async function importEstablishmentList( contId, formList) {
  formList.append('cont_id', contId); 
  const {data} = await api.post(`${apiInternal}/ImportEstablishment`,formList,multiPartHeader);
  return data;
}

export async function reportTroubles(params) {
  const result = await api.post(`${apiInternal}/reportTroubleshoot`,params,partHeader);
  return result;
}

export async function getServices(estaId){
  const {data} = await api.post(`${apiInternal}/getServices`,{esta_id:estaId});
  return data;
}

export async function getMappedLieux(estaId, cntId){
  const {data} = await api.post(`${apiInternal}/establishment/params/getMappedLieux`,{esta_id:estaId, cnt_id: cntId});
  return data;
}

export async function getMappedServices(estaId, cntId){
  const {data} = await api.post(`${apiInternal}/establishment/params/getMappedServices`,{esta_id:estaId, cnt_id: cntId});
  return data;
}

export async function setMappingService(params) {
  const {data} = await api.post(`${apiInternal}/establishment/params/SetMappingService`, params);
  return data;
}

export async function setMappingLieu(params) {
  const {data} = await api.post(`${apiInternal}/establishment/params/SetMappingLieu`, params);
  return data;
}

export async function SetConnector(params) {
  const {data} = await api.post(`${apiInternal}/establishment/params/SetConnector`, params);
  return data;
}

export async function GetConnector(params) {
  const {data} = await api.post(`${apiInternal}/establishment/params/getConnectors`, params);
  return data;
}

export async function getDomains(estaid) {
  const {data} = await api.post(`${apiInternal}/establishment/getDomains`, { esta_id: estaid });
  return data;
}

export async function setDomain(estaid, dacid, label, color, enable) {
  const {data} = await api.post(`${apiInternal}/establishment/setDomain`, {
    esta_id: estaid,
    dac_id: dacid,
    dac_label: label,
    dac_color: color,
    dac_is_enable: enable
  });
  return data;
}

export async function getActivitesFromDomain(estaid, dacid) {
  const {data} = await api.post(`${apiInternal}/establishment/getActivitiesFromDomain`, { esta_id: estaid, dac_id: dacid});
  return data;
}

export async function moveActivitiesToDomain(estaid, activities) {
  const {data} = await api.post(`${apiInternal}/establishment/moveActivitiesToDomain`, { esta_id: estaid, activities});
  return data;
}

export async function createTemplate(name, domains) {
  const {data} = await api.post(`${apiInternal}/establishment/addDomainActivityTemplate`, { template_name: name, activities_domains: domains});
  return data;
}

export async function getTemplatesDomain() {
  const {data} = await api.post(`${apiInternal}/establishment/getAllDomainActivityTemplate`, {});
  return data;
}

export async function applyTemplate(estaid, templateid, replace) {
  const {data} = await api.post(`${apiInternal}/establishment/applyDomainsFromTemplate`, {esta_id: estaid, template_id: templateid, replace});
  return data;
}

export async function isExtraFeaturesActive(estaid) {
  const {data} = await api.post(`${apiInternal}/establishment/isExtraFeaturesActive`, {esta_id: estaid});
  return data;
}

export async function applyExtraFeatures(estaid, features) {
  const {data} = await api.post(`${apiInternal}/establishment/activeExtraFeatures`, {esta_id: estaid, features,});
  return data;
}

export async function getAnonymisations(estaid) {
  const {data} = await api.post(`${apiInternal}/getAnonymisations`, { esta_id: estaid });
  return data;
}